import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../services/api-client';
import type { SearchCapabilities } from '../types/api';

/**
 * O que o fornecedor configurado sabe fazer (SPEC-025 RF-Q03).
 *
 * A tela adapta seus avisos a partir **desta resposta**, nunca de plataforma
 * codificada aqui. É o que mantém o frontend sem conhecer fornecedor (§45): se
 * o provider mudar para um com busca textual, o aviso some sozinho.
 *
 * Cache longo de propósito: capacidade muda com deploy, não durante o uso.
 */
export function useCapabilities() {
  return useQuery({
    queryKey: ['capabilities'],
    queryFn: () => apiRequest<{ platforms: SearchCapabilities[] }>('/capabilities'),
    staleTime: 30 * 60 * 1000,
  });
}
